import { render } from "./ServicePageTR.vue?vue&type=template&id=0ec946cc"
import script from "./ServicePageTR.vue?vue&type=script&lang=js"
export * from "./ServicePageTR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__